'use strict';
require('../../../modules/es.array.copy-within');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'copyWithin');
